template = require('./state_button.html.slim')
controller = require('./state_button_controller')

angular.module('wbComponents').directive 'wbStateButton', ->
  restrict: 'E'
  replace: false
  scope:
    default: '@'
    inProcess: '@'
    done: '@'
    error: '@'
    form: '='
    disableOn: '='
  templateUrl: template
  controller: controller
  controllerAs: 'ctrl'
  bindToController: true
